const __default__ = {
  name: "ForumDashboard"
};
import useSWRV from "swrv";
import { cdate } from "@/utils/cdate";
import { getData } from "@/services/axios";

import { inject } from 'vue';
import { isAuthenticatedKey } from '/codebuild/output/src2081543335/src/cocoo_gov/src/utils/injectionKey.js';
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    // @ts-check
    const isAuthenticated = inject(isAuthenticatedKey);
    const {
      data: forumList
    } = useSWRV(() => isAuthenticated.value && "forum-dashboard", async () => {
      const result = await getData("government_forum", {
        limit: 5
      });
      return result.items;
    }, {
      refreshInterval: 600000,
      // 10分毎
      revalidateOnFocus: false
    });
    return {
      __sfc: true,
      isAuthenticated,
      forumList,
      cdate
    };
  }
});